import { constantTree } from "../../../core/events/ConstantTree";

export const cancelBookingTree = constantTree({
    CancelBooking: {
        Init: "",
        PassengerOutboundCheck: "",
        MainOutboundCheck: "",
        MainInboundCheck:"",
        ConfirmPopupFlag: "",
        ConfirmCancelClick: "",
        BackToBookingClick: "",
        CancelBookingRedirectClick: ""
    }
})